<template>
  <div id="riskManagement">
    <el-card>
      <el-form :model="searchForm" ref="searchForm" label-position="top">
        <el-row>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Project Name:" prop="projectName">
              <el-input clearable v-model="searchForm.projectName" placeholder="Please input" />
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Project Code:" prop="projectNumber">
              <el-input clearable v-model="searchForm.projectNumber" placeholder="Please input" />
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="IPMS ID / PMS ID:" prop="ipmsId">
              <el-input clearable v-model="searchForm.ipmsId" placeholder="Please input" />
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Country:" prop="salesRegion">
              <el-select clearable filterable v-model="searchForm.salesRegion" placeholder="Please select">
                <el-option v-for="item in salesRegionList" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Department:" prop="department">
              <el-select filterable v-model="searchForm.department" clearable placeholder="Please select">
                <el-option v-for="item in deptList" :key="item.deptCode" :label="item.deptEnName" :value="item.deptCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Major Project Level:" prop="majorProjectLevel">
              <el-select clearable v-model="searchForm.majorProjectLevel" placeholder="Please select">
                <el-option v-for="item in majorProjectLevel" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Project Status:" prop="projectStatus">
              <el-select clearable v-model="searchForm.projectStatus" placeholder="Please select">
                <el-option v-for="item in projectStatus" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Risk Type:" prop="riskType">
              <el-select clearable v-model="searchForm.riskType" placeholder="Please select">
                <el-option v-for="item in projectRiskType" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Risk Level:" prop="riskLevel">
              <el-select clearable v-model="searchForm.riskLevel" placeholder="Please select">
                <el-option v-for="item in riskLevel" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- Advanced Filter fields: items 10-12 visible by default on wide screens (4 per row) -->
          <el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch || isWideScreen">
            <el-form-item label="Risk Status:" prop="riskStatus">
              <el-select clearable v-model="searchForm.riskStatus" placeholder="Please select">
                <el-option v-for="item in riskStatus" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch || isWideScreen">
            <el-form-item label="Owner:" prop="owner">
              <el-select v-model="searchForm.owner" clearable filterable remote placeholder="Please input" :remote-method="value => filterUser('personSearchList', value)">
                <el-option v-for="(item, index) in personSearchList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch || isWideScreen">
            <el-form-item label="Planned Closing Date:" prop="plannedClosingDate">
              <el-date-picker v-model="searchForm.plannedClosingDate" type="date" value-format="yyyy-MM-dd" placeholder="Please select" clearable></el-date-picker>
            </el-form-item>
          </el-col>
          <!-- Items 13-15: always hidden unless Advanced Filter is toggled -->
          <el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch">
            <el-form-item label="Risk Closure Date:" prop="riskClosureDate">
              <el-date-picker v-model="searchForm.riskClosureDate" type="date" value-format="yyyy-MM-dd" placeholder="Please select" clearable></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch">
            <el-form-item label="Expiring:" prop="approachingExpiration">
              <el-select clearable v-model="searchForm.approachingExpiration" placeholder="Please select">
                <el-option v-for="item in yesOrNo" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch">
            <el-form-item label="Overdue:" prop="overdue">
              <el-select clearable v-model="searchForm.overdue" placeholder="Please select">
                <el-option v-for="item in yesOrNo" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" style="padding: 10px 0 0 0px;">
            <el-row type="flex" justify="space-between">
              <el-col :span="6" style="text-align: left;">
                <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreateModal()" v-if="canOperate">Create</el-button>
              </el-col>
              <el-col :span="18" style="text-align: right; padding-right: 15px">
                <el-button type="primary" size="small" @click="changeMoreSearch()">Advanced Filter</el-button>
                <el-button type="primary" size="small" @click="handleSearch()">Search</el-button>
                <el-button size="small" @click="handleReset()">Reset</el-button>
                <el-button size="small" :loading="exportLoading" @click="handleExport()">Export</el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <el-table :data="tableData" border v-loading="tableLoading" style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
        <el-table-column prop="projectName" label="Project Name" align="left" min-width="180" fixed="left" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <a style="color:blue;cursor:pointer;" @click="openDetail(scope.row)">{{ scope.row.projectName }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="projectCode" label="Project Code" align="center" min-width="155" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="ipmsPmsId" label="IPMS ID/PMS ID" align="center" min-width="140" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="country" label="Country" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="departmentDesc" label="Department" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="majorProjectLevelDesc" label="Major Project Level" align="center" min-width="185" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.majorProjectLevelDesc" size="small" type="primary">{{ scope.row.majorProjectLevelDesc }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="projectStatusDesc" label="Project Status" align="center" min-width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="riskTypeDesc" label="Risk Type" align="center" min-width="130" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="riskLevel" label="Risk Level" align="center" min-width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span :class="getRiskLevelClass(scope.row.riskLevel)">{{ scope.row.riskLevelDesc }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="riskStatusDesc" label="Risk Status" align="center" min-width="100" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType(scope.row.riskStatus)" size="small" effect="plain">{{ scope.row.riskStatusDesc }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="riskDesc" label="Risk Description" align="left" min-width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="responseMeasures" label="Response Measures" align="left" min-width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="currentProgress" label="Current Progress" align="left" min-width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="ownerDesc" label="Owner" align="center" min-width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="plannedClosingDate" label="Planned Closing Date" align="center" min-width="162" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.plannedClosingDate ? moment(scope.row.plannedClosingDate).format('YYYY-MM-DD') : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="riskClosureDate" label="Risk Closure Date" align="center" min-width="140" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.riskClosureDate ? moment(scope.row.riskClosureDate).format('YYYY-MM-DD') : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="expiring" label="Expiring" align="center" min-width="80" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span :style="scope.row.expiring === 'Yes' ? 'color:#FA8C16;font-weight:500' : ''">{{ scope.row.expiring }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="overdue" label="Overdue" align="center" min-width="80" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span :style="scope.row.overdue === 'Yes' ? 'color:#F5222D;font-weight:500' : ''">{{ scope.row.overdue }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="Operation" align="center" min-width="175" fixed="right" v-if="canOperate">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleModify(scope.row)">Modify</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">Delete</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageDiv" v-if="totalCount && totalCount > 0">
        <el-pagination small layout="total, prev, pager, next, sizes, jumper" :page-sizes="[10, 20, 50, 100]" :current-page.sync="pageNum" :page-size="pageSize" :total="totalCount" @size-change="changePageSize" @current-change="changePage"></el-pagination>
      </div>
    </el-card>

    <!-- Create / Modify Modal -->
    <el-dialog :title="dialogMode === 'create' ? 'Create Risk Record' : 'Modify Risk Record'" width="820px" :visible.sync="dialogVisible" :close-on-click-modal="false" destroy-on-close @close="closeDialog">
      <el-form :model="dialogForm" ref="dialogForm" label-position="top" :validate-on-rule-change="false">
        <el-row>
          <el-col :span="8" v-if="dialogMode === 'create'">
            <el-form-item label="Country:" prop="country" :rules="{ required: true, message: 'Please select' }">
              <el-select clearable v-model="dialogForm.country" placeholder="Please select" @change="onCountryChange">
                <el-option v-for="item in salesRegionList" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="dialogMode === 'create'">
            <el-form-item label="Project Name:" prop="projectId" :rules="{ required: true, message: 'Please select' }">
              <el-select clearable filterable v-model="dialogForm.projectId" placeholder="Please select" :disabled="!dialogForm.country" :loading="projectOptionsLoading" @change="onProjectChange">
                <el-option v-for="item in dialogProjectList" :key="item.projectId" :label="item.projectName" :value="item.projectId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item prop="projectName" v-show="false">
          <el-input v-model="dialogForm.projectName"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="Risk Type:" prop="riskType" :rules="{ required: true, message: 'Please select' }">
              <el-select clearable v-model="dialogForm.riskType" placeholder="Please select">
                <el-option v-for="item in projectRiskType" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Risk Level:" prop="riskLevel" :rules="{ required: true, message: 'Please select' }">
              <el-select clearable v-model="dialogForm.riskLevel" placeholder="Please select"
                :class="dialogForm.riskLevel === 1 ? 'redbg' : dialogForm.riskLevel === 2 ? 'yellowbg' : dialogForm.riskLevel === 3 ? 'greenbg' : ''">
                <el-option v-for="item in riskLevel" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Risk Status:" prop="riskStatus" :rules="{ required: true, message: 'Please select' }">
              <el-select clearable v-model="dialogForm.riskStatus" placeholder="Please select">
                <el-option v-for="item in riskStatus" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="Owner:" prop="owner" :rules="{ required: true, message: 'Please input' }">
              <el-select v-model="dialogForm.owner" clearable filterable remote placeholder="Please input" :remote-method="value => filterUser('personDialogList', value)">
                <el-option v-for="(item, index) in personDialogList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Planned Closing Date:" prop="plannedClosingDate" :rules="{ required: true, message: 'Please select' }">
              <el-date-picker v-model="dialogForm.plannedClosingDate" type="date" value-format="yyyy-MM-dd" placeholder="Please select"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="Risk Description:" prop="riskDesc" :rules="{ required: true, message: 'Please input' }">
              <el-input type="textarea" v-model="dialogForm.riskDesc" :rows="3" placeholder="Please input risk description" maxlength="500" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="Response Measures:" prop="responseMeasures" :rules="{ required: true, message: 'Please input' }">
              <el-input type="textarea" v-model="dialogForm.responseMeasures" :rows="3" placeholder="Please input response measures" maxlength="500" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="Current Progress:" prop="currentProgress" :rules="{ required: true, message: 'Please input' }">
              <el-input type="textarea" v-model="dialogForm.currentProgress" :rows="3" placeholder="Please input current progress" maxlength="500" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog()">Cancel</el-button>
        <el-button type="primary" :loading="dialogLoading" size="small" @click="saveDialog()">Save</el-button>
      </span>
    </el-dialog>

    <!-- Delete Confirm Dialog -->
    <el-dialog width="420px" :visible.sync="deleteVisible" :close-on-click-modal="false" custom-class="delete-dialog">
      <div class="delete-dialog-content">
        <i class="el-icon-warning delete-dialog-icon"></i>
        <p class="delete-dialog-text">Are you sure to delete this risk record of <b>"{{ deleteRowData && deleteRowData.projectName }}"</b>?</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDelete()">Cancel</el-button>
        <el-button type="danger" :loading="deleteLoading" size="small" @click="confirmDelete()">Delete</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'RiskManagement',
  created() {
    this.checkScreenWidth()
    this.getSelectInfo()
    this.getDeptList()
    this.getCountry()

    this.handleSearch()
  },
  mounted() {
    window.addEventListener('resize', this.checkScreenWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenWidth)
  },
  computed: {
    canOperate() {
      const roleName = sessionStorage.getItem('roleName') || '';
      const allowedRoles = ['SystemAdmin', 'ProjectManager（HQ）', 'ServiceManager'];
      return allowedRoles.some(role => roleName.indexOf(role) !== -1);
    }
  },
  data() {
    return {
      moment,
      isWideScreen: false,
      projectRiskType: [],
      riskLevel: [],
      riskStatus: [],
      projectStatus: [],
      majorProjectLevel: [],
      deptList: [],
      salesRegionList: [],
      dialogProjectList: [],
      projectOptionsLoading: false,
      personSearchList: [],
      personDialogList: [],
      yesOrNo: [
        { labelKey: true, labelValue: 'Yes' },
        { labelKey: false, labelValue: 'No' }
      ],
      searchForm: {},
      showMoreSearch: false,
      tableData: [],
      tableLoading: false,
      pageNum: 1,
      pageSize: 10,
      totalCount: 0,
      exportLoading: false,
      dialogVisible: false,
      dialogMode: 'create', // 'create' or 'modify'
      dialogLoading: false,
      dialogForm: {},
      modifyId: null,
      deleteVisible: false,
      deleteLoading: false,
      deleteRowData: null,
    }
  },
  methods: {
    checkScreenWidth() {
      // Element UI xl breakpoint: ≥1920px → 4 items per row (el-col :xl="6")
      this.isWideScreen = window.innerWidth >= 1920
    },
    getSelectInfo() {
      let url = `${this.$store.state.islhurl}configMain/queryLabelList?`;
      let configKeyList = [
        'projectRiskType',
        'riskLevel',
        'riskStatus',
        'projectStatus',
        'majorProjectLevel',
      ]
      url += configKeyList.map(item => `configKeyList=${item}`).join('&')
      const _this = this
      this._post(url).then(
        res => {
          if (res.data && res.code === 200) {
            Object.keys(res.data).forEach(function(key) {
              _this[key] = res.data[key];
            });
          }
        }
      )
    },
    getDeptList() {
      let url = `${this.$store.state.islhurl}dept/getSelectData`;
      let pm = { deptCodechain: 'SelectDept' }
      this._post(url, pm).then(
        res => {
          this.deptList = res.data;
        }
      )
    },
    getCountry() {
      let url = `${this.$store.state.islhurl}risk/database/countryOptions`;
      this._get(url).then(
        res => {
          this.salesRegionList = res.data || [];
        }
      )
    },
    onCountryChange(country) {
      // 选择country后联动查询projectOptions
      this.dialogForm.projectId = null;
      this.dialogForm.projectName = '';
      this.dialogProjectList = [];
      // 清除projectId字段的校验提示，避免自动触发必填校验
      this.$nextTick(() => {
        this.$refs.dialogForm && this.$refs.dialogForm.clearValidate('projectId');
      });
      if (!country) return;
      this.projectOptionsLoading = true;
      let url = `${this.$store.state.islhurl}risk/database/projectOptions?country=${country}`;
      this._get(url).then(res => {
        this.projectOptionsLoading = false;
        if (res.code === 200 && res.data) {
          this.dialogProjectList = res.data;
        } else {
          this.dialogProjectList = [];
        }
      }).catch(() => {
        this.projectOptionsLoading = false;
        this.dialogProjectList = [];
      });
    },
    filterUser(list, query) {
      if (query !== '') {
        if (this.timeout) {
          clearTimeout(this.timeout)
        }
        this.timeout = setTimeout(() => {
          this.fetchUserOptions(list, query)
        }, 200)
      } else {
        this[list] = [];
      }
    },
    fetchUserOptions(list, query) {
      let url = `${this.$store.state.islhurl}user/select-option?keyword=${query}`;
      this._get(url).then().then(res => {
        if (res.code === 200 && res.data) {
          this[list] = res.data;
        } else {
          this[list] = [];
        }
      }).catch(error => {
        this[list] = [];
        console.error('Search failed:', error)
      })
    },
    buildSearchParams() {
      const values = this.searchForm;
      let params = {
        projectName: values.projectName || undefined,
        projectCode: values.projectNumber || undefined,
        ipmsPmsId: values.ipmsId || undefined,
        country: values.salesRegion || undefined,
        department: values.department || undefined,
        majorProjectLevel: values.majorProjectLevel || undefined,
        projectStatus: values.projectStatus || undefined,
        riskType: values.riskType || undefined,
        riskLevel: values.riskLevel || undefined,
        riskStatus: values.riskStatus || undefined,
        owner: values.owner || undefined,
        plannedClosingDate: values.plannedClosingDate || undefined,
        riskClosureDate: values.riskClosureDate || undefined,
        expiring: values.approachingExpiration,
        overdue: values.overdue,
      }
      Object.keys(params).forEach(key => params[key] === undefined && delete params[key])
      return params
    },
    handleSearch() {
      this.pageNum = 1;
      this.fetchData();
    },
    fetchData() {
      let params = this.buildSearchParams()
      this.tableLoading = true;
      let url = `${this.$store.state.islhurl}risk/database/page?pageNum=${this.pageNum}&pageSize=${this.pageSize}`
      this._post(url, params).then(
        res => {
          this.tableLoading = false;
          if (res.code === 200) {
            this.tableData = res.data || [];
            this.totalCount = res.totalSize || 0;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.$message.error(res.msg || 'Failed!');
          }
        }
      ).catch(() => {
        this.tableLoading = false;
      })
    },
    changePageSize(size) {
      this.pageSize = size;
      this.pageNum = 1;
      this.fetchData();
    },
    changePage(current) {
      this.pageNum = current;
      this.fetchData();
    },
    changeMoreSearch() {
      this.showMoreSearch = !this.showMoreSearch;
    },
    handleReset() {
      this.searchForm = {};
      this.pageNum = 1;
      this.handleSearch();
    },
    handleExport() {
      this.exportLoading = true;
      let params = this.buildSearchParams()
      let url = `${this.$store.state.islhurl}risk/database/export`;
      this.$axios({
        url: url,
        method: 'post',
        data: params,
        responseType: 'blob'
      }).then(response => {
        this.exportLoading = false;
        const blob = new Blob([response.data])
        const aEle = document.createElement('a');
        const href = window.URL.createObjectURL(blob);
        aEle.href = href;
        aEle.download = 'Risk Management_' + moment().format('YYYYMMDD') + '.xlsx';
        document.body.appendChild(aEle);
        aEle.click();
        document.body.removeChild(aEle);
        window.URL.revokeObjectURL(href)
      }).catch(() => {
        this.exportLoading = false;
        this.$message.error('Export failed!');
      })
    },
    getRiskLevelClass(level) {
      if (level === 1) return 'risk-level-high';
      if (level === 2) return 'risk-level-medium';
      if (level === 3) return 'risk-level-low';
      return '';
    },
    getStatusTagType(status) {
      if (status === 1) return '';    // Open — 蓝色默认
      return 'info';
    },
    openDetail(record) {
      // 通过sessionStorage传递详情参数，避免被tab系统的router.push覆盖query
      sessionStorage.setItem('majorProjectDetail', JSON.stringify({
        detailId: record.majorProjectId,
        detailStatus: record.projectStatusDesc,
        companyOrRepresentative: record.majorProjectLevel == '4' ? '2' : '1'
      }));
      // 记录来源页签，Return时切回该页签
      sessionStorage.setItem('majorProjectSourceTab', 'riskManagement');
      this.$router.push('/majorProject');
    },
    openCreateModal() {
      this.dialogMode = 'create';
      this.dialogForm = { projectId: null, projectName: '', country: '', riskStatus: null, owner: null, plannedClosingDate: '', riskType: null, riskLevel: null, riskDesc: '', responseMeasures: '', currentProgress: '' };
      this.modifyId = null;
      this.dialogProjectList = [];
      this.personDialogList = [];
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.dialogForm && this.$refs.dialogForm.clearValidate();
      });
    },
    handleModify(row) {
      this.dialogMode = 'modify';
      this.modifyId = row.id;
      this.dialogForm = {
        riskType: row.riskType,
        riskLevel: row.riskLevel,
        riskStatus: row.riskStatus,
        owner: row.owner,
        plannedClosingDate: row.plannedClosingDate,
        riskDesc: row.riskDesc,
        responseMeasures: row.responseMeasures,
        currentProgress: row.currentProgress,
      }
      this.dialogVisible = true;
      // 回显Owner：用owner的值初始化personDialogList，让el-select能匹配到label
      if (row.owner) {
        this.fetchUserOptions('personDialogList', row.owner);
      }
      this.$nextTick(() => {
        this.$refs.dialogForm && this.$refs.dialogForm.clearValidate();
      });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    onProjectChange(projectId) {
      const project = this.dialogProjectList.find(p => p.projectId === projectId);
      if (project) {
        this.dialogForm.projectName = project.projectName;
      }
    },
    saveDialog() {
      this.$refs.dialogForm.validate((valid) => {
        if (!valid) return false;
        this.dialogLoading = true;
        const isCreate = this.dialogMode === 'create';
        let url = `${this.$store.state.islhurl}risk/database/${isCreate ? 'create' : 'modify'}`;
        let params = {
          ...isCreate ? { projectId: this.dialogForm.projectId, projectName: this.dialogForm.projectName } : { id: this.modifyId, riskStatus: this.dialogForm.riskStatus },
          riskType: this.dialogForm.riskType,
          riskLevel: this.dialogForm.riskLevel,
          riskDesc: this.dialogForm.riskDesc,
          responseMeasures: this.dialogForm.responseMeasures,
          currentProgress: this.dialogForm.currentProgress,
          owner: this.dialogForm.owner,
          plannedClosingDate: this.dialogForm.plannedClosingDate || '',
        }
        const requestMethod = isCreate ? '_post' : '_put';
        this[requestMethod](url, params).then(res => {
          this.dialogLoading = false;
          if (res.code === 200) {
            this.$message.success(isCreate ? 'Create Successful!' : 'Modify Successful!');
            this.closeDialog();
            this.handleSearch();
          } else {
            this.$message.error(res.msg || 'Failed!');
          }
        }).catch(() => {
          this.dialogLoading = false;
        })
      });
    },
    handleDelete(row) {
      this.deleteRowData = row;
      this.deleteVisible = true;
    },
    closeDelete() {
      this.deleteVisible = false;
      this.deleteRowData = null;
    },
    confirmDelete() {
      if (!this.deleteRowData) return;
      // 删除风险 DELETE /risk/database/:id
      let url = `${this.$store.state.islhurl}risk/database/${this.deleteRowData.id}`;
      this.deleteLoading = true;
      this._delete(url).then(
        res => {
          this.deleteLoading = false;
          if (res.code === 200) {
            this.$message.success('Delete Successful!');
            this.closeDelete();
            this.handleSearch();
          } else {
            this.$message.error(res.msg || 'Failed!');
          }
        }
      ).catch(() => {
        this.deleteLoading = false;
      })
    },
  }
}
</script>

<style lang="less" scoped>
#riskManagement {
  .hiddencard {
    height: 0;
    overflow: hidden;
  }
  /deep/.el-table .cell {
    word-break: break-word;
  }
  .el-form {
    padding: 0px 0 15px 0;
    .el-form-item {
      margin-bottom: 0px;
      padding: 0 15px 0 0;
    }
    /deep/.el-form-item__label {
      line-height: 22px;
      padding: 9px 12px 0px 0px;
    }
    /deep/.el-select {
      width: 100%;
      .el-select__tags {
        max-width: 100%!important;
      }
    }
    /deep/.el-form-item__content .el-input__suffix {
      left: auto;
      right: 10px;
    }
    /deep/.el-range-editor.el-input__inner {
      width: 100%;
    }
  }
  .el-table {
    /deep/th.el-table__cell>.cell {
      word-break: break-word;
    }
  }
  .pageDiv {
    padding: 16px 0;
    text-align: right;
  }
  .risk-level-high {
    color: #FF0000;
    font-weight: 500;
  }
  .risk-level-medium {
    color: #ddbf05;
    font-weight: 500;
  }
  .risk-level-low {
    color: #6ac903;
    font-weight: 500;
  }
  .redbg /deep/.el-input__inner {
    background: #FF0000;
  }
  .yellowbg /deep/.el-input__inner {
    background: #FFFF00;
  }
  .greenbg /deep/.el-input__inner {
    background: #92D050;
  }
  /deep/.el-dialog__body {
    padding: 10px 20px;
    .el-form {
      padding: 0;
      .el-textarea__inner {
        margin-top: 2px;
      }
    }
    .el-row {
      padding-top: 3px;
    }
  }
  /deep/ .delete-dialog {
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 25px 25px 10px 20px;
    }
    .el-dialog__footer {
      padding: 0px 20px 16px 0px;
    }
    .delete-dialog-content {
      display: flex;
      align-items: flex-start;
      gap: 12px;
    }
    .delete-dialog-icon {
      font-size: 24px;
      color: #E6A23C;
      line-height: 1;
      margin-top: 5px;
    }
    .delete-dialog-text {
      font-size: 15px;
      color: #333;
      line-height: 2;
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/riskmanagement/index.vue